import React, { PureComponent } from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import styles from './Navbar.styles';

class NavbarSidebarButton extends PureComponent {
  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = this.props;

    return (
      <div>
        <button
          type='button'
          className='topbar__button topbar__button--desktop'
          onClick={changeSidebarVisibility}
        >
          <MenuIcon className='topbar__button-icon' style={styles.iconStyle} />
        </button>
        <button
          type='button'
          className='topbar__button topbar__button--mobile'
          onClick={changeMobileSidebarVisibility}
        >
          <MenuIcon className='topbar__button-icon' style={styles.iconStyle} />
        </button>
      </div>
    );
  }
}

export default NavbarSidebarButton;
